import React from 'react';
import styled from 'styled-components';
import { typography } from '../../style/theme';
var SearchResults = styled.div.withConfig({
  displayName: "SearchResultsWrapper__SearchResults",
  componentId: "sc-12asad0-0"
})(["font-size:", "rem;position:absolute;top:calc(100% + 2px);left:0;right:0;background-color:#fff;border-right:1px solid #ddd;border-bottom:1px solid #ddd;border-left:1px solid #ddd;box-shadow:0px 0px 10px #dadada;max-height:320px;"], typography.tiny);

var SearchResultsWrapper = function SearchResultsWrapper(_ref) {
  var children = _ref.children;
  return React.createElement(SearchResults, null, children);
};

export default SearchResultsWrapper;